import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { api,sendAsync } from "../../../app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../../app/store";
import { fromJson, Patientlable } from "../../../models/patientlable"
import * as service from "../../../services/patientlable";
import { PatientTableParams } from "../../../services/patientlable";
interface labelState {
  patientLable:[];
  Total: 0,
  Current: 1,
  detail: Patientlable[];
  lableId:0
}

const initialState: labelState = {
  patientLable:[],
  Total: 0,
  Current: 1,
  detail: [],
  lableId:0
};

const labelSlice = createSlice({
  name: "patientlableSlice",
  initialState,
  reducers: {
    setData(state, action) {
      state.patientLable = action.payload
    },
    setTotal(state, action) {
      state.Total = action.payload
    },
    setCurrent(state, action) {
      state.Current = action.payload
    },
    setDetail: (state, action) => {
      state.detail = action.payload;
    },
    setLableId: (state, action) => {
      state.lableId = action.payload;
    },
  },
});

export const {
  setData, 
  setTotal,
  setCurrent,
  setDetail,
  setLableId
} = labelSlice.actions;

export const selectPatientLable = (state: RootState) => state.patientLable.patientLable

export const selectTotal = (state: RootState) => state.patientLable.Total

export const selectCurrent = (state: RootState) => state.patientLable.Current

export const selectDetail = (state: RootState) => state.patientLable.detail;

export const selectLableId = (state: RootState) => state.patientLable.lableId;

export function getLableList(params: PatientTableParams): RootThunk {
  return api(service.getLableList(params), (data: any, dispatch) => {
    dispatch(setData(data.records))
    dispatch(setTotal(data.total))
  });
}

export function saveLabel(
  body:Patientlable
): RootThunk {
  return api(service.getLableSave( body), (data: any,dispatch) => {
      return
  })
}

export function lableDetail(labelId: string): RootThunk {
  return api(service.getLableDetail(labelId), (data: any, dispatch) => {
    dispatch(setDetail(data));
  });
}


export default labelSlice.reducer;
